import { Modal } from "react-bootstrap";

export function EditIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M4 16.8V20h3.2l9.4-9.4-3.2-3.2L4 16.8zM19.7 7.5a1 1 0 0 0 0-1.4l-1.8-1.8a1 1 0 0 0-1.4 0l-1.4 1.4 3.2 3.2 1.4-1.4z"
      />
    </svg>
  );
}

export function RemoveIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M9 3.5h6l1 2h4v2H4v-2h4l1-2zm-2.2 6h1.7l.4 9h2.2l-.3-9h2.4l-.3 9h2.2l.4-9h1.7l-.7 10.2a1.5 1.5 0 0 1-1.5 1.3H8.9a1.5 1.5 0 0 1-1.5-1.3L6.8 9.5z"
      />
    </svg>
  );
}

export function AdminAddButton({ children, onClick }) {
  return (
    <button type="button" className="admin-add" onClick={onClick}>
      {children}
    </button>
  );
}

export function RecordActions({ name, onEdit, onRemove }) {
  return (
    <span className="company-admin-actions">
      {onEdit ? (
        <button
          type="button"
          className="company-admin-edit"
          aria-label={`Edit ${name}`}
          title={`Edit ${name}`}
          onClick={onEdit}
        >
          <EditIcon />
        </button>
      ) : null}
      {onRemove ? (
        <button
          type="button"
          className="company-admin-remove"
          aria-label={`Remove ${name}`}
          title={`Remove ${name}`}
          onClick={onRemove}
        >
          <RemoveIcon />
        </button>
      ) : null}
    </span>
  );
}

export function AdminFormModal({ show, title, onHide, children, size }) {
  return (
    <Modal show={show} onHide={onHide} centered size={size} className="admin-form-modal" scrollable>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
}

export function AdminFormActions({ onCancel, saveLabel, busy, disabled }) {
  return (
    <div className="admin-form-actions">
      <button type="button" className="btn btn-site-quiet" onClick={onCancel}>
        Cancel
      </button>
      <button type="submit" className="admin-save" disabled={busy || disabled}>
        {busy ? "Saving" : saveLabel}
      </button>
    </div>
  );
}
